"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderRightOutlined = void 0;
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var icon_1 = require("../utils/icon");
exports.FolderRightOutlined = (0, icon_1.makeIcon)({
    Path: function (_a) {
        var colors = _a.colors;
        return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("path", { d: "M1 3.25C1 2.55964 1.55964 2 2.25 2H7.83568C8.10252 2 8.36236 2.08539 8.57718 2.24368L10.2822 3.5H13.75C14.4404 3.5 15 4.05964 15 4.75V12.75C15 13.4404 14.4404 14 13.75 14H2.25C1.55964 14 1 13.4404 1 12.75V3.25ZM2.5 3.5V12.5H13.5V5H10.2C9.93319 5 9.67335 4.91461 9.45853 4.75632L7.75353 3.5H2.5Z", fill: colors[0], fillRule: "evenodd", clipRule: "evenodd" }),
            react_1.default.createElement("path", { d: "M9.03991 10.8159L10.8077 9.0481C11.1006 8.7552 11.1006 8.28033 10.8077 7.98744L9.03991 6.21967C8.74701 5.92678 8.27214 5.92678 7.97925 6.21967C7.68635 6.51256 7.68635 6.98744 7.97925 7.28033L8.50245 7.80353H5.75C5.33579 7.80353 5 8.13932 5 8.55353C5 8.96775 5.33579 9.30353 5.75 9.30353H8.43092L7.97925 9.7552C7.68635 10.0481 7.68635 10.523 7.97925 10.8159C8.27214 11.1088 8.74701 11.1088 9.03991 10.8159Z", fill: colors[0] }));
    },
    name: 'folder_right_outlined',
    defaultColors: ['#D9D9D9'],
    colorful: false,
    allPathData: ['M1 3.25C1 2.55964 1.55964 2 2.25 2H7.83568C8.10252 2 8.36236 2.08539 8.57718 2.24368L10.2822 3.5H13.75C14.4404 3.5 15 4.05964 15 4.75V12.75C15 13.4404 14.4404 14 13.75 14H2.25C1.55964 14 1 13.4404 1 12.75V3.25ZM2.5 3.5V12.5H13.5V5H10.2C9.93319 5 9.67335 4.91461 9.45853 4.75632L7.75353 3.5H2.5Z', 'M9.03991 10.8159L10.8077 9.0481C11.1006 8.7552 11.1006 8.28033 10.8077 7.98744L9.03991 6.21967C8.74701 5.92678 8.27214 5.92678 7.97925 6.21967C7.68635 6.51256 7.68635 6.98744 7.97925 7.28033L8.50245 7.80353H5.75C5.33579 7.80353 5 8.13932 5 8.55353C5 8.96775 5.33579 9.30353 5.75 9.30353H8.43092L7.97925 9.7552C7.68635 10.0481 7.68635 10.523 7.97925 10.8159C8.27214 11.1088 8.74701 11.1088 9.03991 10.8159Z'],
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
});
